import type {
  CreditCard_CreditCard_Fragment,
  CreditCard_CreditCardPendingOrder_Fragment,
} from 'common/graphql/fragments/creditCard.gql';

export const isCreditCardPendingOrder = (
  fragment:
    | CreditCard_CreditCard_Fragment
    | CreditCard_CreditCardPendingOrder_Fragment,
): fragment is CreditCard_CreditCardPendingOrder_Fragment => {
  return fragment.__typename === 'CreditCardPendingOrder';
};
